import { Directive, ElementRef, HostListener, Input } from "@angular/core";

/**
 * Limita el número de dígitos permitidos en un input.
 * Útil para inputs type="number" donde maxlength no tiene efecto en HTML5.
 * Solo permite caracteres numéricos y trunca al número de dígitos indicado.
 */
@Directive({
	selector: "[appMaxDigits]",
})
export class MaxDigitsDirective {
	/** Número máximo de dígitos (por defecto 3). */
	@Input() appMaxDigits: number | string = 3;

	constructor(private el: ElementRef<HTMLInputElement>) {}

	@HostListener("input")
	onInput(): void {
		const input = this.el.nativeElement;
		const raw = input.value;
		const digitsOnly = raw.replace(/\D/g, "");
		const maxValue =
			typeof this.appMaxDigits === "number"
				? this.appMaxDigits
				: parseInt(this.appMaxDigits, 10);
		const max = Math.max(0, Number.isFinite(maxValue) ? maxValue : 0);
		if (digitsOnly.length > max) {
			const truncated = digitsOnly.slice(0, max);
			input.value = truncated;
			input.dispatchEvent(new Event("input", { bubbles: true }));
		} else if (raw !== digitsOnly) {
			input.value = digitsOnly;
			input.dispatchEvent(new Event("input", { bubbles: true }));
		}
	}
}
